<p-dialog [(visible)]="display" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
  [styleClass]="'contextMenuModal settingsModal'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000"
  [closeOnEscape]="true" [style]="{'height':'700px','max-width':'930px', 'width': '100%'}" [resizable]="false">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between">
      <span
        style="font-size: 16px;color:#FFFFFF;font-family:OpenSansSemiBold, sans-serif;line-height: 21.79px;font-weight: 600;">Search External Client</span>
      <button type="button" (click)="hideModal(gfcForm)" class="d-flex flex-row close qma-text"
        style="margin: 0px 6px 0px 0px;">
        <img src="assets/qwyn/icons/close-grey.svg" alt="Close">
      </button>
    </div>
  </p-header>
  <div class="gfid-body">
    <form #gfcForm="ngForm" (ngSubmit)="gfcForm.valid && validateAndSearch(gfcForm)">
      <div class="d-flex flex-row align-items-center mt-3 pe-4">
        <div class="me-3" style="font-family: OpenSans, sans-serif;color: #2f2f2f;">Search by:</div>
        <div *ngFor="let item of radioButtons; let i = index" class="me-3" >
          <input type="radio" [attr.id]="item.name+'_'+i" name="filCriteria"
            [value]="item.val" [(ngModel)]="gfcModel.filCriteria" (change)="onSelectCriteria(item)" class="me-1">
          <label style="font-family: OpenSans, sans-serif;color: #2f2f2f;" class="custom-control-label" [attr.for]="item.name+'_'+i">{{item.name}}</label>
        </div>
        <div *ngIf="gfcModel.accCriteria" class="d-flex flex-row align-items-center flex-grow-1">
          <div class="ms-4 me-4 pt-2">
            <label for="from">Branch</label>
          </div>
          <div class="pt-1">
            <input type="text" placeholder="Enter branch..." [(ngModel)]="gfcModel.acctBranch" #acctBranch="ngModel" name="acctBranch"
             class="w-75 t-box" />
          </div>
        </div>
      </div>
      <div class="d-flex flex-row mt-4">
          <p-dropdown [styleClass]="'signatureDropdown drop-down group-details-inp drop-admin'" [ngStyle]="{ width: '200px', 'max-width': '200px' }" placeholder="Select..."
            [(ngModel)]="gfcModel.filterType" name="filterType" [options]="['Contains','Begins With','Equals']"
            >
          </p-dropdown>
        <div class="search-holder">
          <div class="input-group search">
                <input class="px-2 py-1 w-100 input-text" type="text" #filterVal="ngModel" placeholder='Search...' [(ngModel)]="gfcModel.filterVal" name='filterVal'
                  style='background-color: #F8F9FC; height: 34px;border-top-right-radius: 4px;border-bottom-right-radius: 4px;'>
            <div class="input-group-btn searchBox">
              <button type="submit" class="btn btn-default">
                <span>
                  <img style="width:18px;height:24px;" src='assets/core/layout/header/search_active.svg' alt="Search">
                </span>
              </button>
            </div>
          </div>
          <div class="form-control-feedback text-danger" *ngIf="filterVal.errors && (filterVal.dirty || filterVal.touched )">
            <p class="text-danger" *ngIf="filterVal.errors.required">Input is required</p>
            <p class="text-danger" *ngIf="filterVal.errors.minlength">Please enter atleast 3 character</p>
          </div>
        </div>
      </div>
    </form>
    <div class="grid-holder mt-4">
      <div *ngIf="firstLoad">
      <ag-grid-angular *ngIf="!gfcModel.accCriteria" style="height:350px;" class="ag-theme-balham peerTable"
        [gridOptions]="gridOptions" [rowData]="rowData" [columnDefs]="columnDefs" (gridReady)="onGridReady($event)" (suppressHorizontalScroll)="true"
        (rowClicked)='onRowClicked($event)' [suppressPaginationPanel]="true" (paginationChanged)="onPaginationChanged($event)" [modules]="modules">
      </ag-grid-angular>
      <ag-grid-angular *ngIf="gfcModel.accCriteria" style="height:350px;" class="ag-theme-balham peerTable"
        [gridOptions]="gridOptions" [rowData]="rowData" [columnDefs]="accountColumnDefs" (gridReady)="onGridReady($event)" (suppressHorizontalScroll)="true"
        (rowClicked)='onRowClicked($event)' [suppressPaginationPanel]="true" (paginationChanged)="onPaginationChanged($event)" [modules]="modules">
      </ag-grid-angular>
      <div style="margin-top: 1%;height:3vh!important" class="d-flex justify-content-end qma-mailbox-pagination-container">
        <span class="value" id="lbPageSize">{{lbPageSize}}</span> <span class="separator"> of </span>
        <span class="value separator" id="lbTotalRecords">{{lbTotalRecords}}</span>
        <span class="separator separator-right"> Inquiries </span>

        <span>
          <img [ngClass]="{'pagination-img-disabled':disablePaginationPrevFirst}" (click)="onBtFirst()" id="btFirst"
            class="pagination-img" src="assets/Inbox/pagination-arrow-first.svg" alt="First"/>
        </span>
        <span class="separator-right">
          <img id="btPrevious" [ngClass]="{'pagination-img-disabled':disablePaginationPrevFirst}" (click)="onBtPrevious()"
            class="pagination-img" src="assets/Inbox/pagination-arrow-prev.svg" alt="Previous" />
        </span>

        <span class="separator-right pagination-text-padding">Page </span>
        <span id="lbCurrentPage" class="separator-right pagination-text-padding">{{lbCurrentPage}}</span>
        <span class="separator-right pagination-text-padding">of</span>
        <span id="lbTotalPages" class="separator-right pagination-text-padding">{{lbTotalPages}}</span>

        <span>
          <img [ngClass]="{'pagination-img-disabled':disablePaginationNextLast}" id="btNext" (click)="onBtNext()"
            class="pagination-img" src="assets/Inbox/pagination-arrow-dark.svg" alt="Next"/>
        </span>
        <span class="separator-right">
          <img [ngClass]="{'pagination-img-disabled':disablePaginationNextLast}" id="btLast" (click)="onBtLast()"
            class="pagination-img" src="assets/Inbox/pagination-arrow-dark1.svg" alt="Last"/>
        </span>
      </div>
    </div>
    </div>
    <p class="text-danger" *ngIf="maxRecords">Results limited to first 5000 search items!</p>
  </div>
    <p-footer style="position: absolute; width: 100% ; bottom: -6px; right: 0;">
      <div class="d-flex flex-row footer-btn-container"></div>
      <div class="d-flex flex-row flex-wrap bottom-button-holder pb-3 pt-3 justify-content-end">
        <button type="reset" class="btn clear-btn me-4" (click)="hideModal(gfcForm)">Cancel</button>
        <button type="submit" (click)="addGFID(gfcForm)" class="btn search-btn">Add</button>
      </div>
    </p-footer>
</p-dialog>